import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Registro anterior deshabilitado en navegación. Componentes y servicios se conservan.
// import { TemplateRegistoComponent } from './template-registo/template-registo.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
// import { InicioRegistroComponent } from '../core/inicio-registro/inicio-registro.component';
// Solicitud anterior deshabilitada en navegación. Componentes se conservan.
// import { SolicitudComponent } from './solicitud/solicitud.component';
import { UserGuard } from './guards/user.guard';
import { EncuestaComponent } from './forms/encuesta/encuesta.component';
import { AceptacionSolicitudCreditoComponent } from './aceptacion-solicitud-credito/aceptacion-solicitud-credito.component';
import { AceptacionEncuestaComponent } from './aceptacion-encuesta/aceptacion-encuesta.component';
import { CambiarContrasenaComponent } from './cambiar-contrasena/cambiar-contrasena.component';
import { TemplateActualizarDatosComponent } from './template-actualizar-datos/template-actualizar-datos.component';
import { EliminarCuentaComponent } from './eliminar-cuenta/eliminar-cuenta.component';
import { sessionHomeRedirectGuard } from '../core/session-home-redirect.guard';
import { SessionHomeRedirectComponent } from '../core/session-home-redirect.component';
import { campaniaRegistroRedirectGuard } from '../core/campania-registro-redirect.guard';
import { PerfilHubComponent } from './perfil/hub/perfil-hub.component';
import { PerfilSobreTiComponent } from './perfil/sobre-ti/perfil-sobre-ti.component';
import { PerfilSobreNegocioComponent } from './perfil/sobre-negocio/perfil-sobre-negocio.component';
import { PerfilSobreIngresosComponent } from './perfil/sobre-ingresos/perfil-sobre-ingresos.component';
import { PerfilSolicitaCreditoComponent } from './perfil/solicita-credito/perfil-solicita-credito.component';
import { PerfilSolicitudEnviadaComponent } from './perfil/solicitud-enviada/perfil-solicitud-enviada.component';
import { PerfilOfertasComponent } from './perfil/ofertas/perfil-ofertas.component';
import { PerfilAlianzaComponent } from './perfil/alianza/perfil-alianza.component';
import { perfilSeccionGuard } from './perfil/progress/perfil-seccion.guard';

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { 
        path: 'home', 
        component: HomeComponent,
        canActivate: [UserGuard]
    },
    {
        path: 'perfil',
        component: PerfilHubComponent,
        canActivate: [UserGuard],
    },
    {
        path: 'perfil/sobre-ti',
        component: PerfilSobreTiComponent,
        canActivate: [UserGuard, perfilSeccionGuard],
    },
    {
        path: 'perfil/sobre-negocio',
        component: PerfilSobreNegocioComponent,
        canActivate: [UserGuard, perfilSeccionGuard],
    },
    {
        path: 'perfil/sobre-ingresos',
        component: PerfilSobreIngresosComponent,
        canActivate: [UserGuard, perfilSeccionGuard],
    },
    {
        path: 'perfil/solicita-credito',
        component: PerfilSolicitaCreditoComponent,
        canActivate: [UserGuard],
    },
    {
        path: 'perfil/solicitud-enviada',
        component: PerfilSolicitudEnviadaComponent,
        canActivate: [UserGuard],
    },
    {
        path: 'perfil/solicitud-enviada/:id',
        component: PerfilSolicitudEnviadaComponent,
        canActivate: [UserGuard],
    },
    {
        path: 'perfil/ofertas/:id',
        component: PerfilOfertasComponent,
        canActivate: [UserGuard],
    },
    {
        path: 'perfil/alianza',
        component: PerfilAlianzaComponent,
        canActivate: [UserGuard],
    },
    // {
    //     path: 'registro/:persona',
    //     component: TemplateRegistoComponent,
    // },
    // {
    //     path: 'registro',
    //     component: InicioRegistroComponent,
    // },
    // Compat NeoCampania: URLs legacy → Home canónico (no reabre form registro viejo).
    {
        path: 'registro/:persona/:id/:token',
        canActivate: [campaniaRegistroRedirectGuard],
        component: SessionHomeRedirectComponent,
    },
    // Solicitud anterior (forms PN/PJ): no reabre el formulario; URL → home del micro.
    // {
    //     path: 'solicitud',
    //     component: SolicitudComponent,
    //     canActivate: [UserGuard]
    // },
    // {
    //     path: 'solicitud/:id',
    //     component: SolicitudComponent,
    //     canActivate: [UserGuard]
    // },
    {
        path: 'solicitud',
        redirectTo: '/microempresario/home',
        pathMatch: 'full',
    },
    {
        path: 'solicitud/:id',
        redirectTo: '/microempresario/home',
    },
    {
        path: 'propuestas/:id',
        redirectTo: '/microempresario/perfil/ofertas/:id',
    },
    { path: 'encuesta-satifaccion/:id', component: EncuestaComponent, canActivate: [UserGuard] },
    { path: 'solicitudAceptada/:id', component: AceptacionSolicitudCreditoComponent, canActivate: [UserGuard] },
    { path: 'finalizarEncuesta', component: AceptacionEncuestaComponent, canActivate: [UserGuard] },
    { path: 'cambiar-contrasena', component: CambiarContrasenaComponent, canActivate: [UserGuard] },
    { path: 'actualizar-datos', component: TemplateActualizarDatosComponent, canActivate: [UserGuard] },    
    { path: 'deshabilitar-usuario', component: EliminarCuentaComponent, canActivate: [UserGuard] },
    {
        path: '**',
        canActivate: [sessionHomeRedirectGuard],
        component: SessionHomeRedirectComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MicroempresarioRoutingModule { }
